import { useEffect } from 'react';

import TokenManager from '@viome/viome-base/src/api/TokenManager';
import { LocalStorage } from '@/utils/LocalStorage';
import EventTracker from '@utils/EventTracker';
import { useIframeModeStore } from '@/hooks/useIframeModeStore';

const useInitialization = () => {
  useEffect(() => {
    const storageProvider = {
      set: (key: string, value: string) => LocalStorage.setItem(key, value),
      getString: (key: string) => LocalStorage.getItem(key) || null,
      delete: (key: string) => LocalStorage.removeItem(key),
    };
    EventTracker.initialize();
    TokenManager.setStorageProvider(storageProvider);
    TokenManager.setClientVersion('7.5.0');
    TokenManager.setClientType('Web');

    const iframeState = useIframeModeStore.getState();
    if (iframeState.isIframeMode) {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');
      if (token) {
        TokenManager.setAuthToken(token);
        const url = new URL(window.location.href);
        url.searchParams.delete('token');
        window.history.replaceState({}, '', url.toString());
      }
    }
  }, []);
};

export default useInitialization;